import { render, staticRenderFns } from "./LeaveList.vue?vue&type=template&id=1ebe262e&scoped=true"
import script from "./LeaveList.vue?vue&type=script&lang=js"
export * from "./LeaveList.vue?vue&type=script&lang=js"
import style0 from "./LeaveList.vue?vue&type=style&index=0&id=1ebe262e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebe262e",
  null
  
)

export default component.exports